export default __webpack_public_path__ + "img/pin_icons/stairs_w.png";